import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'
import {
    TableResponse,
} from 'app/types/request.types'
import requests from 'app/requests/Order/Order.requests'
import {
    PreviousOrderViewFields,
} from '../../../../orders.types'

const useGetPreviousOrdersByOrder = (orderNumber: string) => {
    const {
        onParamsChange,
        loadData,
    } = useRequestTable<TableResponse<PreviousOrderViewFields>>({
        config: requests.previousOrders,
        params: {
            orderNumber,
        },
        defaultValue: {
            sort: {
                field: 'changedOn',
                direction: 'desc',
            },
        },
        key: RequestKeys.getPreviousOrdersByOrder,
    })

    return {
        onParamsChange,
        loadData,
    }
}

export default useGetPreviousOrdersByOrder
